import { UseIsVisibleType } from "@website/hooks/is-visible/is-visible.types";
import { RefObject, useEffect, useRef, useState } from "react";

export const useIsVisible: UseIsVisibleType = (options, defaultValue) => {
  const reference = useRef<HTMLDivElement>();
  const [inView, setInView] = useState(defaultValue || false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => setInView?.(entry.isIntersecting),
      options ?? {}
    );
    const reference_ = reference.current;
    reference_ && observer?.observe(reference_);
    return () => {
      reference_ && observer?.unobserve(reference_);
    };
  }, [options]);

  return {
    reference: reference as RefObject<HTMLDivElement>,
    inView
  };
};
